import PrintPoster from "@/components/PrintPoster";
import { SURVEY_SHORT_LINK } from "@/data/links";

const STEPS = [
  "Open your phone camera and point it at the QR code.",
  "Tap the link that appears to open the Family Survey.",
  "Answer once for your whole household — it only takes a few minutes.",
];

export default function SurveyPoster() {
  return (
    <PrintPoster
      testId="survey-poster"
      docTitle="Family Survey Poster"
      kicker="Parish Family Survey"
      title={<>Every family counts in the <span className="italic text-terracotta">household of God.</span></>}
      intro="Help your GKK and our parish know and care for every family. Scan the code and answer the survey today."
      qrValue={SURVEY_SHORT_LINK}
      urlLabel={SURVEY_SHORT_LINK.replace("https://", "")}
      steps={STEPS}
      footerNote="Your answers are kept private by the Parish · mabuhayparish.org"
    />
  );
}
